function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import { jsx } from 'panel';
import { EditorUser, MixpanelUserItem } from 'common/widgets/user-list/types';
import { HeaderUserInfo } from 'common/widgets/user-list/types';
import { UserListEl } from 'common/widgets/user-list';
import { IconSizeType } from 'common/constants';
import { formatDate } from './util';
export const CreatorWithViewsIcon = (_ref: {
  userListSel?: string;
  trackingProps?: {
    [key: string]: string | number;
  };
  entityEditor?: HeaderUserInfo;
  entityCreator?: HeaderUserInfo;
  presenceViews?: MixpanelUserItem[];
  totalPresenceViews: number;
}) => {
  let {
    userListSel,
    trackingProps,
    entityEditor,
    entityCreator,
    presenceViews,
    totalPresenceViews
  }: {
    userListSel?: string;
    trackingProps?: {
      [key: string]: string | number;
    };
    entityEditor?: HeaderUserInfo;
    entityCreator?: HeaderUserInfo;
    presenceViews?: MixpanelUserItem[];
    totalPresenceViews: number;
  } = _ref;
  const users: MixpanelUserItem[] = [];

  // First (displayed) icon is creator
  if (entityCreator) {
    const {
      id,
      name,
      email,
      date
    } = entityCreator;
    const formattedDate = formatDate(date, "MMM DD, YYYY");
    users.push({
      id,
      name,
      email,
      'label-prefix': "Created by",
      'label-suffix': formattedDate
    });
  }
  let editorUser: EditorUser;
  if (entityEditor) {
    const {
      name,
      email,
      date
    } = entityEditor;
    const formattedDate = formatDate(date, "MMM DD, YYYY \u2022 h:mm A");
    editorUser = {
      name,
      email,
      dateStr: formattedDate
    };
  }

  // If there's only one view, it's the user who just created the entity.
  // Don't show the overflow in that case.
  if ((presenceViews === null || presenceViews === void 0 ? void 0 : presenceViews.length) > 1) {
    users.push(...presenceViews);
  }
  return users.length ? <UserListEl sel={userListSel} attrs={{
    users,
    'max-icons-displayed': 1,
    elref: "userList",
    size: IconSizeType.Small,
    'track-properties': trackingProps,
    'editor-user': editorUser,
    'user-count-override': totalPresenceViews > 1 ? totalPresenceViews : 0
  }} data-sentry-element="UserListEl" data-sentry-component="CreatorWithViewsIcon" data-sentry-source-file="presets.tsx" /> : null;
};

/**
 * Logic here:
 * if there's online user, then show them in the first layer
 */
export const OnlineUsers = (_ref2: {
  userListSel: string;
  trackingProps: {
    [key: string]: string | number;
  };
  onlineUsers: Array<{
    id: number;
    name: string;
    color: string;
    email: string;
  }>;
  entityEditor: HeaderUserInfo;
  entityCreator: HeaderUserInfo;
  presenceViews: MixpanelUserItem[];
}) => {
  let {
    userListSel,
    trackingProps,
    onlineUsers,
    entityEditor,
    entityCreator,
    presenceViews
  }: {
    userListSel: string;
    trackingProps: {
      [key: string]: string | number;
    };
    onlineUsers: Array<{
      id: number;
      name: string;
      color: string;
      email: string;
    }>;
    entityEditor: HeaderUserInfo;
    entityCreator: HeaderUserInfo;
    presenceViews: MixpanelUserItem[];
  } = _ref2;
  const users: MixpanelUserItem[] = onlineUsers.slice(0, 4).map(user => ({
    id: user.id,
    name: user.name,
    color: user.color,
    email: user.email,
    'label-prefix': user.id === (entityCreator === null || entityCreator === void 0 ? void 0 : entityCreator.id) ? "Created by" : undefined,
    'label-suffix': user.id === (entityCreator === null || entityCreator === void 0 ? void 0 : entityCreator.id) ? formatDate(entityCreator.date, "MMM DD, YYYY") : undefined,
    isOffline: false
  }));
  users.push(...presenceViews.map(user => _objectSpread(_objectSpread({}, user), {}, {
    isOffline: !onlineUsers.some(onlineUser => onlineUser.id === user.id)
  })));
  let editorUser: EditorUser;
  if (entityEditor) {
    const {
      name,
      email,
      date
    } = entityEditor;
    const formattedDate = formatDate(date, "MMM DD, YYYY \u2022 h:mm A");
    editorUser = {
      name,
      email,
      dateStr: formattedDate
    };
  }
  return users.length ? <UserListEl sel={userListSel} attrs={{
    users,
    // max should 4 online users
    'max-icons-displayed': Math.min(onlineUsers.length, 4),
    elref: "userList",
    size: IconSizeType.Small,
    'track-properties': trackingProps,
    'editor-user': editorUser
  }} data-sentry-element="UserListEl" data-sentry-component="OnlineUsers" data-sentry-source-file="presets.tsx" /> : null;
};